<template>
  <div>
      <div class="title">{{items.name}} ({{items.info.length}})</div>
      <div>
          <goods v-for="(item,index) in items.info" :key="index" :data="item"></goods>
      </div>
  </div>
</template>

<script>
import goods from '../shopping/goodsRow.vue'
export default {
  components: { goods },
    props:[
        'items'
    ]
}
</script>

<style lang="scss" scoped>
.title{
  background: #f1f1f1;
  margin: 20px;
  font-size: 26px;
  height: 70px;
  line-height: 70px;
  padding: 0 20px;
  font-weight: bold;
  border-radius: 8px;
}
</style>